import { create } from 'zustand';

export const useBigdesImplementationProcessEvaluationStore = create((set) => ({
    items: [],
    loading: false,
    error: null,
    searchParams: {
        page: 1,
        pageSize: 20,
        sortBy: 'questionNo',
        sortOrder: 'asc',
        search: '',
    },
    paginationData: {
        total: 0,
        totalPages: 0,
        page: 1,
        pageSize: 20,
    },
    updateDialogOpen: false,
    dialogRow: null,

    setItems: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    setSearchParams: (params) => set((state) => ({
        searchParams: { ...state.searchParams, ...params },
    })),
    setPaginationData: (paginationData) => set({ paginationData }),
    updateItemInList: (item) => set((state) => ({
        items: state.items.map((row) => (row.id === item.id ? item : row)),
    })),
    openUpdateDialog: (row) => set({ updateDialogOpen: true, dialogRow: row }),
    closeUpdateDialog: () => set({ updateDialogOpen: false, dialogRow: null }),
}));
